import React from 'react'

const Jva_Ls = () => {
    return (
        <div className='container'>
            <h1>Java Program for Linear Search</h1>
            <p><p><strong>Problem:</strong> Given an array arr[] of n elements, write a function to search a given element x in arr[].<br/></p></p>
            <div class="containers">
  <div class="line number1 index0 alt2"><code class="comment">// Java code for linearly search x in arr[]. If x</code>
  </div>
  <div class="line number2 index1 alt1"><code class="comment">// is present then return its location, otherwise</code>
  </div>
  <div class="line number3 index2 alt2"><code class="comment">// return -1</code></div>
  <div class="line number4 index3 alt1"><code class="keywords">class</code> <code class="plain">LinearSearch &#123;</code>
  </div>
  <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// This function returns index of element x in arr[]</code></div>
  <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">static</code> <code class="keywords">int</code> <code class="plain">search(</code><code
      class="keywords">int</code> <code class="plain">arr[], </code><code class="keywords">int</code> <code
      class="plain">n, </code><code class="keywords">int</code> <code class="plain">x)</code></div>
  <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number8 index7 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">for</code>
    <code class="plain">(</code><code class="keywords">int</code> <code class="plain">i = </code><code
      class="value">0</code><code class="plain">; i &lt; n; i++) &#123;</code></div>
  <div class="line number9 index8 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// Return the index of the element if the element</code></div>
  <div class="line number10 index9 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// is found</code></div>
  <div class="line number11 index10 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">if</code> <code class="plain">(arr[i] == x)</code></div>
  <div class="line number12 index11 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">return</code> <code class="plain">i;</code></div>
  <div class="line number13 index12 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
  <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
  <div class="line number15 index14 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// return -1 if the element is not found</code></div>
  <div class="line number16 index15 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">return</code> <code class="plain">-</code><code class="value">1</code><code class="plain">;</code>
  </div>
  <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
  <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">public</code> <code class="keywords">static</code> <code class="keywords">void</code> <code
      class="plain">main(String[] args)</code></div>
  <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number21 index20 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">int</code><code class="plain">[] arr = &#123; </code><code class="value">3</code><code
      class="plain">, </code><code class="value">4</code><code class="plain">, </code><code class="value">1</code><code
      class="plain">, </code><code class="value">7</code><code class="plain">, </code><code class="value">5</code> <code
      class="plain">&#125;;</code></div>
  <div class="line number22 index21 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
    <code class="plain">n = arr.length;</code></div>
  <div class="line number23 index22 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
  <div class="line number24 index23 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
    <code class="plain">x = </code><code class="value">4</code><code class="plain">;</code></div>
  <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
  <div class="line number26 index25 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
    <code class="plain">index = search(arr, n, x);</code></div>
  <div class="line number27 index26 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">if</code>
    <code class="plain">(index == -</code><code class="value">1</code><code class="plain">)</code></div>
  <div class="line number28 index27 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">System.out.println(</code><code class="string">"Element is not present in the array"</code><code
      class="plain">);</code></div>
  <div class="line number29 index28 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">else</code>
  </div>
  <div class="line number30 index29 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">System.out.println(</code><code class="string">"Element found at position "</code> <code
      class="plain">+ index);</code></div>
  <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number32 index31 alt1"><code class="plain">&#125;</code></div>
</div>
<div class="output"><b>Output:</b><pre>Element found at position 1
</pre></div>
        </div>
    )
}

export default Jva_Ls
